import React, { useEffect, useMemo, useState, useContext } from "react";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import config from "../../../config/config";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import html2pdf from "html2pdf.js";
import { toastError, toastSuccess } from "../../../common/Toast";
import { changePriceFormat, ExportExcel } from "../../../common/common";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import Select from "react-select";
import { Box, Button } from "@mui/material";
import { createRow } from "material-react-table";
import SearchIcon from "@mui/icons-material/Search";
import { AppContext } from "../../../context/AppContext";
import moment from "moment";
import CurrencySymbols from "../../../common/CurrencySymbol";
import CommonDatePicker from "../../../components/DatePicker/CommonDatePicker";

const DriverTaskReceipt = () => {
    const { CurrencySymbol, FractionDigits, dateFormate } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [string, setstring] = useState("");
  const [data, setData] = useState([]);
  const paramObject = useParams();
  const location = localStorage.getItem("Location");
  const token = localStorage.getItem("Token");
  const ID = localStorage.getItem("ID");  

  const navigate = useNavigate();

  const [employeeFilterId, setEmpolyeeFilterId] = useState(0);
  const [usersDropdown, setUsersDropdown] = useState([]);

  const [custOptions, setCustOptions] = useState([]);
  const [customerID, setCustomerID] = useState(0);

  const [updateToTaskId, setUpdateToTaskId] = useState(0);
  const [taskIdsOptions, setTaskIdsOptions] = useState([]);

  const [rowSelectData, setRowSelectData] = useState([]);
  const [rowSelection, setRowSelection] = useState({});
  const [showDriverEdit, setShowDriverEdit] = useState(false);
  const [showScheduledateEdit, setShowScheduledateEdit] = useState(false);
  const [scheduleDate, setScheduleDate] = useState(moment().format("YYYY-MM-DD"));
  const [newRow, setNewRow] = useState(false);
  // const [emptyInputBox, setEmptyInputBox] = useState(false);

  const [invoiceFindvalue, setInvoiceFindvalue] = useState("");

  const [moveTaskToDriverId, setMoveTaskToDriverId] = useState(0);

  console.log(updateToTaskId, "updateToTaskId");
  console.log(rowSelectData, "rowSelectData");

  useEffect(() => {
    const result = Object.keys(rowSelection).map(Number);
    setRowSelectData(result);
    result.length === 0 && setEmpolyeeFilterId(0);
  }, [rowSelection]);

  const columns = [
    {
      header: "#",
      accessorKey: "index",
      Cell: ({ row }) => (
        <div className="d-flex align-items-center">
          {row.index + 1}
          {row.original.Id == 0 && (
            <div
              title="Delete"
              className="cursor-pointer ml-2"
              onClick={() => handleItemsDelete(row.index)}
            >
              <i
                className="fa fa-trash text-red fs-3"
                data-bs-toggle="tooltip"
                title="Delete"
              ></i>
            </div>
          )}
        </div>
      ),
      size: 50,
    },
    {
      header: "BOX",
      accessorKey: "Box",
      Cell: ({ row }) => (
        <input
          value={row.original.Box}
          type="text"
          className="form-control"
          onChange={(e) => handleEditChange(row.index, "Box", e.target.value)}
          style={{ width: "85px", marginRight: "20px" }}
          placeholder="Box"
        />
      ),
      size: 120,
    },
    {
      header: "REP",
      accessorKey: "REP",
    },
    {
      header: "Route",
      accessorKey: "Routess",
      Cell: ({ row }) =>
        row.original.type === "empty" ? (
          <input
            value={row.original.Routess}
            type="text"
            className="form-control"
            onChange={(e) =>
              handleEditChange(row.index, "Routess", e.target.value)
            }
            style={{ width: "85px", marginRight: "20px" }}
            placeholder="Routess"
          />
        ) : (
          row.original.Routess
        ),
      size: 120,
    },
    {
      header: "Customer Name",
      accessorKey: "companyname",
      Cell: ({ row }) =>
        row.original.type === "empty" ? (
          <input
            value={row.original.companyname}
            type="text"
            className="form-control"
            onChange={(e) =>
              handleEditChange(row.index, "companyname", e.target.value)
            }
            style={{ width: "85px", marginRight: "20px" }}
            placeholder="companyname"
          />
        ) : row.original.companyname?.length > 0 ? (
          row.original.companyname
        ) : (
          <div>
            <Select
              onChange={(event) => {
                // row.index, "Balance", e.target.value
                handelCustomerSelect(row.index, "CustomerSelect", event);
              }}
              options={custOptions}
              backspaceRemovesValue={false}
              controlShouldRenderValue={true}
              isClearable={true}
              styles={CUSTOM_SELECT_DROPDOWN_STYLE}
              className="custom-search-select mt-1"
              value={custOptions?.find((el) => el?.value == customerID)}
              menuPortalTarget={document.body} // To prevent overflow issues
              // styles={{
              //   menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              // }}
            />
          </div>
        ),
      size: 150,
    },
    {
      header: "Invoice No",
      accessorKey: "InvoiceNo",
      Cell: ({ row }) =>
        row.original.type === "empty" ? (
          <input
            value={row.original.InvoiceNo}
            type="text"
            className="form-control"
            onChange={(e) =>
              handleEditChange(row.index, "InvoiceNo", e.target.value)
            }
            style={{ width: "85px", marginRight: "20px" }}
            placeholder="InvoiceNo"
          />
        ) : row.original.saleId > 0 ? (
          <Link
            to={`/sales-receipt/${row.original.InvoiceNo}`}
            target="_blank"
            style={{
              textDecoration: "underline",
              textUnderlineOffset: "3px",
            }}
          >
            {row.original.InvoiceNo}
          </Link>
        ) :  (row.original.saleId == 0 && !row.original.companyname) ? ( // row.index == 0
          <div className="d-flex align-items-center">
            <input
              value={row.original.saleinvoiceSearch}
              type="text"
              className="form-control"
              onChange={(e) => handleEditChange(row.index, "saleinvoiceSearch", e.target.value)}
              // onChange={(e) => setInvoiceFindvalue(e.target.value)}
              placeholder="Search Invoice"
            />
            <div
              onClick={() => checkInvoiceandAddRowData(row.index, row.original.saleinvoiceSearch)}
              className="cursor-pointer fs-4 m-1"
            >
              <i class="fa fa-search"></i>
            </div>
          </div>
        ) : (
          ""
        ),
      size: 120,
    },
    {
      header: "Total",
      accessorKey: "Total",
      Cell: ({ row }) =>
        row.original.type === "empty" ? (
          <input
            value={row.original.Total}
            type="text"
            className="form-control"
            onChange={(e) =>
              handleEditChange(row.index, "Total", e.target.value)
            }
            style={{ width: "85px", marginRight: "20px" }}
            placeholder="Total"
          />
        ) : (
          CurrencySymbols(
            Number(row.original.Total),
            CurrencySymbol,
            FractionDigits
          )
        ),
      size: 100,
    },    
    {
      header: "Quickbook Open Balance",
      accessorKey: "Balance",
      Cell: ({ row }) => (
        <input
          value={`${CurrencySymbol}${row.original.Balance}`} // Display the value with CurrencySymbol
          type="text" // Use "text" to allow formatted values with symbols
          className="form-control"
          onChange={(e) => {
            const rawValue = e.target.value.replace(CurrencySymbol, "").trim(); // Remove CurrencySymbol
            const numericValue = (rawValue); // Parse to a number
            if (!isNaN(numericValue)) {
              handleEditChange(row.index, "Balance", numericValue); // Update state with numeric value
            }
          }}
          style={{ width: "85px", marginRight: "20px" }}
          placeholder="Previous"
        />
      ),
      size: 150,
    },
    { 
      header: "Cash",
      accessorKey: "Cash",
      Cell: ({ row }) => (
        <input
          value={row.original.Cash}
          type="text"
          className="form-control"
          onChange={(e) => handleEditChange(row.index, "Cash", e.target.value)}
          style={{ width: "85px", marginRight: "20px" }}
          placeholder="Cash"
        />
      ),
      size: 100,
    },
    {
      header: "Check",
      accessorKey: "Checks",
      Cell: ({ row }) => (
        <input
          value={row.original.Checks}
          type="text"
          className="form-control"
          onChange={(e) =>
            handleEditChange(row.index, "Checks", e.target.value)
          }
          style={{ width: "85px", marginRight: "20px" }}
          placeholder="Checks"
        />
      ),
      size: 100,
    },
    {
      header: "Notes",
      accessorKey: "Notes",
      Cell: ({ row }) => (
        <input
          value={row.original.Notes}
          type="text"
          className="form-control"
          onChange={(e) => handleEditChange(row.index, "Notes", e.target.value)}
          style={{ width: "85px" }}
          placeholder="Notes"
        />
      ),
      size: 150,
    },
    {
      header: "Action",
      accessorKey: "action",
      Cell: ({ row }) =>
        row.original.saleId > 0 ? (
          <button
            className="btn btn-sm btn-secondary"
            onClick={() =>
              window.open(`/print-sales-receipts?id=${row.original.InvoiceNo}`, '_blank')
            }
          >
            Print
          </button>
        ) : null,
      size: 100,
    },
  ];

  const fatchReceipt = () => {
    axios
      .get(
        `${config.salesconfigBaseUrl}/sales/drivertaskreceipt?locationid=${location}&ID=${paramObject?.id}`,
        {
          headers: {
            'Content-Type': "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        const mainData = response.data.ResponseData;

        // Step 1: Group by customerQB and sum the Totals
        const groupedData = mainData.reduce((acc, item) => {
          const customerQB = item.customerQB;
          const total = parseFloat(item.Total);

          if (!acc[customerQB]) {
            acc[customerQB] = { FinalTotal: 0 };
          }
          acc[customerQB].FinalTotal += total;

          return acc;
        }, {});

        console.log(groupedData, "groupedData");

        // Step 2: Map over the original data to add FinalTotal
        const updatedData = mainData.map((item) => ({
          ...item,
          FinalTotal: groupedData[item.customerQB].FinalTotal.toFixed(2), // Add FinalTotal to each entry
          Balance: Number(item?.Balance || 0).toFixed(2),
          Total: Number(item?.Total || 0).toFixed(2),
        }));
        setData(updatedData);
        setScheduleDate(updatedData[0]?.ScheduleDate);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fatchReceipt();

    axios
      .get(`${config.employeesBaseUrl}/employees/usersdropdown`, {
        headers: {
          'Content-Type': "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        const maindata = res.data.ResponseData.map((u, i) => {
          return { label: u.Name, value: u.Id };
        });

        setUsersDropdown(maindata);
      });

    axios
      .get(`${config.customersBaseUrl}/customers/customerdropdown`, {
        headers: {
          'Content-Type': "application/json;charset=UTF-8",
          'Access-Control-Allow-Origin': "*",
          Authorization: token,
        },
      })
      .then((response) => {
        const customerDropDown = response.data.ResponseData.map((option) => ({
          value: option.Id,
          label: option.CompanyName,
          address: option.Address1,
          email: option.Email,
          Route: option.Route,
          customerQB: option.QuickbookID,
        }));
        setCustOptions(customerDropDown);
        console.log(response.data.ResponseData, "===> setCustOptions");
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handelChnageTaskToEmployee = (employeeId) => {
    setEmpolyeeFilterId(employeeId);
    if (employeeId != 0) {
      axios
        .get(
          `${config.salesconfigBaseUrl}/sales/drivertaskslist?employeeId=${employeeId}`,
          {
            headers: {
              'Content-Type': "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          console.log("usersdropdown", res);

          const maindata = res.data.ResponseData.map((u, i) => {
            return {
              label: `TaskID: (${u.ID}) Count: (${u.InvoiceCount}) Driver: ${u.AssignTo} (Date: ${u.CreatedDate})`,
              value: u.ID,
            };
          });
          setUpdateToTaskId(0);
          setTaskIdsOptions(maindata);
        });
    } else {
      setUpdateToTaskId(0);
    }
  };

  const handelUpdatetask = () => {
    const updateObject = {
      taskID: paramObject?.id,
      employeeId: employeeFilterId,
      movedToTaskId: updateToTaskId,
      SalesList: rowSelectData.join(","), // now we pass taskitem id
      loginuserId: ID,
      location: location,
      model: "driverreport",
    };

    console.log(updateObject, "updateObject");
    // return;
    axios
      .post(
        `${config.salesconfigBaseUrl}/sales/drivertaskUpdate`,
        updateObject,
        {
          headers: {
            'Content-Type': "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        if (response.data.ResponseCode === "SUCCESS") {
          toastSuccess(response.data.ResponseMessage);
          setUpdateToTaskId(0);
          setEmpolyeeFilterId(0);
          setRowSelection({});
          setRowSelectData([]);
          // Navigate("/Driver-Task-List");
          fatchReceipt();
        } else {
          toastError(response.data.ResponseMessage);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handlepaymentdatechange = (event) => {
    setScheduleDate(event);
  };


const onPrintAllInvoices = async () => {
  const invoiceIds =  data.filter(el => el.InvoiceNo).map(el => el.InvoiceNo)?.join(',')
  window.open(`/print-sales-receipts?id=${invoiceIds}`, '_blank');
};



  const handlePrint = (e) => {
    e.preventDefault();

    let emptyMaiRows = "";
    for (let i = 0; i < 5; i++) {
      emptyMaiRows += `
    <tr>
        <td style="border: 1px solid black; padding: 8px; height: 30px;"></td>
        <td style="border: 1px solid black; padding: 8px; height: 30px;width:80px;"></td>
        <td style="border: 1px solid black; padding: 8px; height: 30px;width:80px;"></td>
        <td style="border: 1px solid black; padding: 8px; height: 30px;"></td>
        <td style="border: 1px solid black; padding: 8px; height: 30px;width:200px;"></td>
        <td style="border: 1px solid black; padding: 8px; height: 30px;"></td>
        <td style="border: 1px solid black; padding: 8px; height: 30px;"></td>
        <td style="border: 1px solid black; padding: 8px; height: 30px;"></td>
        <td style="border: 1px solid black; padding: 8px; height: 30px;"></td>
        <td style="border: 1px solid black; padding: 8px; height: 30px;width:350px;"></td>
    </tr>`;
    }

    let printContainer = document.createElement("div");

    let header = document.createElement("div");
    header.style.display = "flex";
    header.style.alignItems = "center";
    header.style.marginBottom = "10px";
    header.innerHTML = `
    <p style="font-size: 15px;">
        Delivery manifest: ${moment(data[0]?.CreatedDate).format(`${dateFormate.toUpperCase()}`)} &nbsp;&nbsp;&nbsp;&nbsp;
        Driver: ${data[0]?.employees} &nbsp;&nbsp;&nbsp;&nbsp;
        Departure time: ______________________ &nbsp;&nbsp;&nbsp;&nbsp;
        Vehicles:
    </p>
    `;

    // <span style="margin-right: 20px;">Delivery manifest: ${data[0]?.CreatedDate}</span>
    // <span style="margin-right: 20px;">Driver: ${data[0]?.employees}</span>
    // <span style="margin-right: 80px;">Departure time: </span>
    // <span style="margin-right: 20px;">Vehicles: </span>

    // Append header to printContainer
    printContainer.appendChild(header);

    // Build the HTML table structure with border styling
    printContainer.innerHTML += `
      <table class="table mt-1" style="border-collapse: collapse; width: 100%;">
        <thead>
          <tr>
            <th style="border: 1px solid black; padding: 8px;height: 30px;">#</th>
            <th style="border: 1px solid black; padding: 8px;height: 30px;width:30px;">BOX</th>
            <th style="border: 1px solid black; padding: 8px;height: 30px;width:30px;">REP</th>
            <th style="border: 1px solid black; padding: 8px;height: 30px;">INV</th>
            <th style="border: 1px solid black; padding: 8px;height: 30px;width:200px;">Name</th>
            <th style="border: 1px solid black; padding: 8px;height: 30px;">Amount</th>
            <th style="border: 1px solid black; padding: 8px;height: 30px;">Previous</th>
            <th style="border: 1px solid black; padding: 8px;height: 30px;width:100px;">Cash</th>
            <th style="border: 1px solid black; padding: 8px;height: 30px;width:100px;">Check</th>
            <th style="border: 1px solid black; padding: 8px;height: 30px;width:350px;">Notes</th>
          </tr>
        </thead>
        <tbody>
          ${data
            .map(
              (item, index) => `
              <tr style="font-weight: bold;">
                <td style="border: 1px solid black; padding: 8px;height: 30px;font-weight: bold;">${
                  index + 1
                }</td>
                <td style="border: 1px solid black; padding: 8px;height: 30px;width:30px;font-weight: bold;">${
                  item?.Box
                }</td>
                <td style="border: 1px solid black; padding: 8px;height: 30px;width:30px;font-weight: bold;">${
                  item?.REP
                }</td>
                <td style="border: 1px solid black; padding: 8px;height: 30px;font-weight: bold;">${
                  item?.InvoiceNo
                }</td>
                <td style="border: 1px solid black; padding: 8px;height: 30px;width:200px;font-weight: bold;">${
                  item?.companyname
                }</td>
                <td style="border: 1px solid black; padding: 8px;height: 30px;font-weight: bold;">$${changePriceFormat(
                  item?.Total
                )}</td>
                <td style="border: 1px solid black; padding: 8px;height: 30px;font-weight: bold;">$${changePriceFormat(
                  item?.Balance
                )}</td>
                <td style="border: 1px solid black; padding: 8px;height: 30px;width:100px;font-weight: bold;">${
                  item?.Cash
                }</td>
                <td style="border: 1px solid black; padding: 8px;height: 30px;width:100px;font-weight: bold;">${
                  item?.Checks
                }</td>
                <td style="border: 1px solid black; padding: 8px;height: 30px;width:350px;font-weight: bold;">${
                  item?.Notes
                }</td>
              </tr>
            `
            )
            .join("")}
            ${emptyMaiRows}
        </tbody>
      </table>
    `;

    // Create a new page container
    let page = document.createElement("div");
    page.style.padding = "0 20px";
    page.style.pageBreakAfter = "always"; // Ensure the main content ends and a new page starts

    // Footer (to be on a new page with 15 empty rows)
    let footer = document.createElement("div");
    footer.style.pageBreakBefore = "always"; // Ensure the footer starts on a new page

    // Generate 15 empty rows for the footer table
    let emptyRows = "";
    for (let i = 0; i < 15; i++) {
      emptyRows += `
        <tr>
          <td style="border: 1px solid black; padding: 8px;height: 30px;"></td>
          <td style="border: 1px solid black; padding: 8px;height: 30px;width:200px;"></td>
          <td style="border: 1px solid black; padding: 8px;height: 30px;"></td>
          <td style="border: 1px solid black; padding: 8px;height: 30px;"></td>
          <td style="border: 1px solid black; padding: 8px;height: 30px;width:350px;"></td>
        </tr>
      `;
    }

    footer.innerHTML = `
      <table class="table mt-1" style="border-collapse: collapse; width: 100%;">
        <thead>
          <tr>
            <th style="border: 1px solid black; padding: 8px;height: 30px;">INV</th>
            <th style="border: 1px solid black; padding: 8px;height: 30px;width:200px;">Name</th>
            <th style="border: 1px solid black; padding: 8px;height: 30px;">Returned Items Details</th>
            <th style="border: 1px solid black; padding: 8px;height: 30px;">QTY</th>
            <th style="border: 1px solid black; padding: 8px;height: 30px;width:350px;">Notes</th>
          </tr>
        </thead>
        <tbody>
          ${emptyRows}
        </tbody>
      </table>
    `;

    page.appendChild(footer.cloneNode(true));
    printContainer.appendChild(page.cloneNode(true));

    setTimeout(() => {
      const opt = {
        margin: 0.2,
        filename: "Invoice.pdf",
        html2canvas: { scale: 5 },
        jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
      };

      html2pdf()
        .from(printContainer)
        .set(opt)
        .output("blob")
        .then((pdfBlob) => {
          const pdfUrl = URL.createObjectURL(pdfBlob);
          window.open(pdfUrl, "_blank");
        })
        .catch((err) => {
          console.error("Error generating PDF:", err);
        });
    }, 50);

    const Itemobj = {};

    Itemobj.Driveritems = data;
    let itemjsonstring = JSON.stringify(Itemobj);

    let SalesData = {
      xmldriveritems: itemjsonstring,
      loginUserId: ID,
    };

    axios
      .post(
        `${config.salesconfigBaseUrl}/sales/UpdateCustomerData`,
        SalesData,
        {
          headers: {
            'Content-Type': "application/json;charset=UTF-8",
            'Access-Control-Allow-Origin': "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const handleDownload = (e) => {
    e.preventDefault();

    let emptyMaiRows = "";
    for (let i = 0; i < 5; i++) {
      emptyMaiRows += `
    <tr>
        <td style="border: 1px solid black; padding: 8px; height: 30px;"></td>
        <td style="border: 1px solid black; padding: 8px; height: 30px;width:80px;"></td>
        <td style="border: 1px solid black; padding: 8px; height: 30px;"></td>
        <td style="border: 1px solid black; padding: 8px; height: 30px;width:200px;"></td>
        <td style="border: 1px solid black; padding: 8px; height: 30px;"></td>
        <td style="border: 1px solid black; padding: 8px; height: 30px;"></td>
        <td style="border: 1px solid black; padding: 8px; height: 30px;"></td>
        <td style="border: 1px solid black; padding: 8px; height: 30px;"></td>
        <td style="border: 1px solid black; padding: 8px; height: 30px;width:350px;"></td>
    </tr>`;
    }

    let printContainer = document.createElement("div");

    let header = document.createElement("div");
    header.style.display = "flex";
    header.style.alignItems = "center";
    header.style.marginBottom = "10px";
    header.innerHTML = `
     <p style="font-size: 15px;">
        Delivery manifest: ${data[0]?.CreatedDate} &nbsp;&nbsp;&nbsp;&nbsp;
        Driver: ${data[0]?.employees} &nbsp;&nbsp;&nbsp;&nbsp;
        Departure time: ______________________ &nbsp;&nbsp;&nbsp;&nbsp;
        Vehicles:
    </p>
    `;

    // <span style="margin-right: 20px;">Delivery manifest: ${data[0]?.CreatedDate}</span>
    // <span style="margin-right: 20px;">Driver: ${data[0]?.employees}</span>
    // <span style="margin-right: 80px;">Departure time: </span>
    // <span style="margin-right: 20px;">Vehicles: </span>

    // Append header to printContainer
    printContainer.appendChild(header);

    // Build the HTML table structure with border styling
    printContainer.innerHTML += `
      <table class="table mt-1" style="border-collapse: collapse; width: 100%;">
        <thead>
          <tr>
            <th style="border: 1px solid black; padding: 8px;">#</th>
            <th style="border: 1px solid black; padding: 8px;width:30px;">BOX</th>
            <th style="border: 1px solid black; padding: 8px;">INV</th>
            <th style="border: 1px solid black; padding: 8px;width:200px;">Name</th>
            <th style="border: 1px solid black; padding: 8px;">Amount</th>
            <th style="border: 1px solid black; padding: 8px;">Previous</th>
            <th style="border: 1px solid black; padding: 8px;width:100px;">Cash</th>
            <th style="border: 1px solid black; padding: 8px;width:100px;">Check</th>
            <th style="border: 1px solid black; padding: 8px;width:350px;">Notes</th>
          </tr>
        </thead>
        <tbody>
          ${data
            .map(
              (item, index) => `
              <tr style="font-weight: bold;">
                <td style="border: 1px solid black; padding: 8px;font-weight: bold;">${
                  index + 1
                }</td>
                <td style="border: 1px solid black; padding: 8px;width:30px;font-weight: bold;">${
                  item?.Box
                }</td>
                <td style="border: 1px solid black; padding: 8px;font-weight: bold;">${
                  item?.InvoiceNo
                }</td>
                <td style="border: 1px solid black; padding: 8px;width:200px;font-weight: bold;">${
                  item?.companyname
                }</td>
                <td style="border: 1px solid black; padding: 8px;font-weight: bold;">$${changePriceFormat(
                  item?.Total
                )}</td>
                  <td style="border: 1px solid black; padding: 8px;font-weight: bold;">$${changePriceFormat(
                    item?.Balance
                  )}</td>
                <td style="border: 1px solid black; padding: 8px;width:100px;font-weight: bold;">${
                  item?.Cash
                }</td>
                <td style="border: 1px solid black; padding: 8px;width:100px;font-weight: bold;">${
                  item?.Checks
                }</td>
                <td style="border: 1px solid black; padding: 8px;width:350px;font-weight: bold;">${
                  item?.Notes
                }</td>
              </tr>
            `
            )
            .join("")}
          ${emptyMaiRows}
        </tbody>
      </table>
    `;

    // Create a new page container
    let page = document.createElement("div");
    page.style.padding = "0 20px";
    page.style.pageBreakAfter = "always"; // Ensure the main content ends and a new page starts

    // Footer (to be on a new page with 15 empty rows)
    let footer = document.createElement("div");
    footer.style.pageBreakBefore = "always"; // Ensure the footer starts on a new page

    // Generate 15 empty rows for the footer table
    // Generate 15 empty rows for the footer table
    let emptyRows = "";
    for (let i = 0; i < 15; i++) {
      emptyRows += `
    <tr>
      <td style="border: 1px solid black; padding: 8px; height: 30px;"></td>
      <td style="border: 1px solid black; padding: 8px;width:200px; height: 30px;"></td>
      <td style="border: 1px solid black; padding: 8px; height: 30px;"></td>
      <td style="border: 1px solid black; padding: 8px; height: 30px;"></td>
      <td style="border: 1px solid black; padding: 8px;width:350px; height: 30px;"></td>
    </tr>
  `;
    }

    footer.innerHTML = `
      <table class="table mt-1" style="border-collapse: collapse; width: 100%;">
        <thead>
          <tr>
            <th style="border: 1px solid black; padding: 8px;">INV</th>
            <th style="border: 1px solid black; padding: 8px;width:200px;">Name</th>
            <th style="border: 1px solid black; padding: 8px;">Returned Items Details</th>
            <th style="border: 1px solid black; padding: 8px;">QTY</th>
            <th style="border: 1px solid black; padding: 8px;width:350px;">Notes</th>
          </tr>
        </thead>
        <tbody>
          ${emptyRows}
        </tbody>
      </table>
    `;

    page.appendChild(footer.cloneNode(true));
    printContainer.appendChild(page.cloneNode(true));

    setTimeout(() => {
      const opt = {
        margin: 0.2,
        filename: "Invoice.pdf",
        html2canvas: { scale: 5 },
        jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
      };

      html2pdf()
        .from(printContainer)
        .set(opt)
        .save()
        .then((pdfBlob) => {
          const pdfUrl = URL.createObjectURL(pdfBlob);
          window.open(pdfUrl, "_blank");
        })
        .catch((err) => {
          console.error("Error generating PDF:", err);
        });
    }, 50);

    const Itemobj = {};
    Itemobj.Driveritems = data;
    let itemjsonstring = JSON.stringify(Itemobj);

    let SalesData = {
      xmldriveritems: itemjsonstring,
      loginUserId: ID,
    };

    axios
      .post(
        `${config.salesconfigBaseUrl}/sales/UpdateCustomerData`,
        SalesData,
        {
          headers: {
            'Content-Type': "application/json;charset=UTF-8",
            'Access-Control-Allow-Origin': "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  console.log(data, "datacheck");

  const handleopenbal = () => {
    let QuickbookIdstr = "";

    QuickbookIdstr = data.map(
      (item) => `'${item?.customerQB == null ? 0 : item?.customerQB}'`
    );

    let reqobj = {
      loginuserid: ID,
      QuickbookIdstr: QuickbookIdstr,
    };
    setLoading(true);
    axios
      .post(
        `${config.salesconfigBaseUrl}/sales/getcustomeropenbalance`,
        reqobj,
        {
          headers: {
            'Content-Type': "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res.data.Customer, "logcount");

        let maped = {};

        // Map the Customer data to an object where the key is Id and the value is Balance
        res.data.Customer?.forEach((item) => {
          maped[item.Id] = item?.Balance;
        });

        console.log(maped, "maped");

        let matchedCustomers = new Set(); // To track customerQB values that have been matched

        let newarray = data.map((obj) => {
          if (matchedCustomers.has(obj?.customerQB)) {
            return {
              ...obj,
              Balance: 0, // Set balance to 0 if the customerQB has already been matched
            };
          } else {
            let currentQBs = maped[obj?.customerQB];
            matchedCustomers.add(obj?.customerQB); // Mark customerQB as matched
            return {
              ...obj,
              Balance: currentQBs ? Number(currentQBs || 0) - Number(obj?.FinalTotal || 0) : 0, // Update balance if matched, otherwise set to 0
            };
          }
        });

        console.log(newarray, "updated data");

        setData(newarray);
        toastSuccess("Data fetch From QB Sucessfully ");
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const muiRowDragHandleProps = ({ table }) => ({
    onDragEnd: () => {
      const { draggingRow, hoveredRow } = table.getState();
      if (hoveredRow && draggingRow) {
        data.splice(hoveredRow.index, 0, data.splice(draggingRow.index, 1)[0]);
        setData([...data]);
      }
    },
  });

  const onSubmitTaskData = () => {
    console.log(moveTaskToDriverId, data, "latest data");

    const updateData = data.map((el, index) => {
      return {
        ...el,
        index: index + 1,
        saleID: el.saleId,
        InvoiceNo: el.InvoiceNo,
        SaleType: "Sale",
        Total: el.Total,
        CompanyName: el.companyname,
        DeliveryStatus: "",
        Route: el.Routess,
        Balance: el.Balance,
        Customerid: el.Customerid
      };
    });

    const Itemobj = {};

    Itemobj.Driveritems = updateData;
    let itemjsonstring = JSON.stringify(Itemobj);

    let SalesData = {
      xmldriveritems: itemjsonstring,
      employeid: showDriverEdit ? moveTaskToDriverId : data[0]?.EmployeeID ? data[0].EmployeeID : 0,
      loginUserId: ID,
      location: location,
      id: paramObject.id,
      scheduleDate: scheduleDate
    };

    console.log(SalesData, "SalesData");
    // return
    setLoading(true);
    axios
      .post(`${config.salesconfigBaseUrl}/sales/DriverTaskData`, SalesData, {
        headers: {
          'Content-Type': "application/json;charset=UTF-8",
          'Access-Control-Allow-Origin': "*",
          Authorization: token,
        },
      })
      .then((res) => {
        if (res.data.ResponseCode == "SUCCESS") {
          toastSuccess("Task Update Success");
          setShowDriverEdit(false);
          fatchReceipt();
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const uniqueRoutess = [...new Set(data?.map((item) => item.Routess))];
  let concatenatedRoutess = uniqueRoutess?.join(", ");

  const handleEditChange = (rowIndex, field, value) => {
    const updatedData = [...data];
    updatedData[rowIndex] = {
      ...updatedData[rowIndex],
      [field]: value,
    };
    setData(updatedData); // Update the state with the new value
  };

  const addNewRow = (type) => {
    // if (!newRow) {
    const newRowData = {
      Id: 0,
      TaskId: paramObject.id,
      companyname: "",
      InvoiceNo: "",
      Total: "",
      CreatedDate: "",
      ModifiedDate: "",
      Routess: "",
      employees: "",
      customerQB: 0,
      CreatedBy: "",
      ModifiedBy: "",
      Box: "",
      Checks: "",
      Cash: "",
      Notes: "",
      rowOrder: 0,
      Balance: "",
      saleId: 0,
      type: type,
      saleinvoiceSearch:"",
      Customerid: 0
    };

    let updatedData = [...data];
    updatedData.unshift(newRowData);
    setData(updatedData); // Update the state with the new value

    // if (!emptyInputBox) {
    //   setNewRow(true);
    // }
    // }
  };

  const checkInvoiceandAddRowData = (index,saleinvoiceSearch) => {
    axios
      .get(
        `${config.salesconfigBaseUrl}/sales/findsalebyinvoiceno?InvoiceNo=${saleinvoiceSearch}`,
        {
          headers: {
            'Content-Type': "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        const mainData = response.data.ResponseData;
        if (mainData?.length > 0) {
          console.log(mainData[0], "mainData");
          const newobj = mainData[0];

          if (data.some((el) => el.saleId == newobj.saleId)) {
            toastError(`invoice ${newobj.saleId} already Exist`);
            return;
          }
          const updatedData = [...data];
          updatedData[index] = {
            ...updatedData[index],
            companyname: newobj?.CompanyName,
            InvoiceNo: newobj?.InvoiceNo,
            Total: newobj?.Total,
            Routess: newobj?.Route,
            customerQB: newobj?.customerQB,
            saleId: newobj?.saleId,
            type: "invoice",
            saleinvoiceSearch:"",
            Customerid: newobj.Customerid
          };
          setData(updatedData);
          setNewRow(false);
        } else {
          toastError("invoice Not Found");
        }
        setInvoiceFindvalue("");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handelCustomerSelect = (index, field, event) => {
    console.log(index, event, "selected Customer");

    if (event) {
      const updatedData = [...data];
      updatedData[index] = {
        ...updatedData[index],
        companyname: event?.label,
        InvoiceNo: "",
        Total: 0,
        Routess: event?.Route,
        customerQB: event?.customerQB,
        saleId: 0,
        type: "customer",
        saleinvoiceSearch: "",
        Customerid: event?.value
      };
      setData(updatedData);
      setNewRow(false);
      // setCustomerID(event.value);
    } else {
      setCustomerID(0);
    }
  };

  const handleItemsDelete = (index) => {
    console.log(index, "delete index");
    let updatedData = [...data];
    updatedData.splice(index, 1);
    setData(updatedData);
    if (index == 0) {
      setNewRow(false);
    }
  };

  console.log(data, "handleOnChangeValue 2");

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "11px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item" style={{ marginLeft: "11px" }}>
                  <Link to="/Driver-Task-List">Driver Task List</Link>
                </li>
                <li className="breadcrumb-item active">Driver task Receipt </li>
              </ul>
            </div>
          </div>

          <Link
            className="btn btn-sm btn-secondary me-1 "
            onClick={handlePrint}
          >
            print
          </Link>
          <Link
            className="btn btn-sm btn-secondary me-1 "
            onClick={handleDownload}
          >
            Download
          </Link>
          <Link
            className="btn btn-sm btn-secondary me-1 "
            onClick={() => ExportExcel(data, "AllData", "DriverDailySheet")}
          >
            Export Excel
          </Link>
          <Link
            className="btn btn-sm btn-secondary me-1 "
            onClick={handleopenbal}
          >
            Fetch Customer OpenBal
          </Link>
          <Link
            className="btn btn-sm btn-secondary me-1 "
            onClick={() => fatchReceipt()}
            title="Re-fetch Data"
          >
            <i class="fa fa-refresh"></i>
          </Link>
          <button
            className="btn btn-sm btn-primary me-1 "
            onClick={() => onSubmitTaskData()}
            title="Save Task"
          >
            Save Task
          </button>
          <button
            className="btn btn-sm btn-primary me-1 "
            onClick={() => onPrintAllInvoices()}
            title="Print Invoice"
          >
            Print Invoices
          </button>
          <div className="row m-3">
            {/* <div className="col-md-2">
              <span className="bold">Update Driver Task:</span>
            </div> */}
            <div className="col-md-3">
              Employee:
              <Select
                options={usersDropdown}
                className="custom-search-select mt-1"
                value={
                  employeeFilterId > 0
                    ? usersDropdown.find((el) => el.value === employeeFilterId)
                    : null
                }
                isClearable={true}
                onChange={(event) =>
                  handelChnageTaskToEmployee(event?.value ? event?.value : 0)
                }
                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                isDisabled={rowSelectData.length === 0}
              />
            </div>
            <div className="col-md-3">
              Move Task TO:
              <Select
                options={taskIdsOptions}
                className="custom-search-select mt-1"
                value={
                  updateToTaskId > 0
                    ? taskIdsOptions.find((el) => el.value == updateToTaskId)
                    : null
                }
                isClearable={true}
                onChange={(event) =>
                  setUpdateToTaskId(event?.value ? event?.value : 0)
                }
                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                isDisabled={employeeFilterId === 0}
              />
            </div>
            <div className="col-md-3">
              {rowSelectData?.length > 0 && (
                <button
                  className="btn btn-primary btn-sm mt-4"
                  onClick={() => handelUpdatetask()}
                >
                  {rowSelectData?.length > 0 &&
                  employeeFilterId === 0 &&
                  updateToTaskId === 0
                    ? "UnAssigned"
                    : employeeFilterId > 0 && updateToTaskId === 0
                    ? "Create a New Task"
                    : `Assign To ${
                        usersDropdown.find(
                          (el) => el.value === employeeFilterId
                        )?.label
                      }`}
                </button>
              )}
            </div>
          </div>
          <div id="print" className="receipt-card-body">
            <div className="card-body">
              <div>
                <div
                  style={{
                    color: "#000 !important",
                    textAlign: "left !important",
                  }}
                >
                  <div>
                    <p
                      className="p-medium"
                      style={{
                        fontFamily: "Inter, sans-serif",
                        color: "black",
                      }}
                    >
                      Task ID : {paramObject?.id ? paramObject?.id : 0}
                    </p>
                    <p
                      className="p-medium"
                      style={{
                        fontFamily: "Inter, sans-serif",
                        color: "black",
                      }}
                    >
                      {" "}
                      Route : {concatenatedRoutess}
                    </p>
                    <p
                      className="p-medium"
                      style={{
                        fontFamily: "Inter, sans-serif",
                        color: "black",
                      }}
                    >
                      {" "}
                      Driver Name : {data[0]?.employees}{" "}
                      <i
                        class={`fa ${
                          showDriverEdit ? "fa-times" : "fa-edit"
                        } cursor-pointer`}
                        onClick={() => setShowDriverEdit(!showDriverEdit)}
                      ></i>
                      {showDriverEdit && (
                        <div className="col-md-3">
                          Move Task To Driver:
                          <Select
                            options={usersDropdown}
                            className="custom-search-select mt-1"
                            value={
                              moveTaskToDriverId > 0
                                ? usersDropdown.find(
                                    (el) => el.value === moveTaskToDriverId
                                  )
                                : null
                            }
                            // isClearable={true}
                            onChange={(event) =>
                              setMoveTaskToDriverId(
                                event?.value ? event?.value : 0
                              )
                            }
                            styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                          />
                        </div>
                      )}
                    </p>
                    <p
                      className="p-medium"
                      style={{
                        fontFamily: "Inter, sans-serif",
                        color: "black",
                      }}
                    >
                      {" "}
                      Vehicle :
                    </p>
                  </div>

                  <div className="row mt-3">
                    <div className="col-md-6">
                      <p
                        className="p-medium"
                        style={{
                          fontFamily: "Inter, sans-serif",
                          color: "black",
                        }}
                      >
                        {" "}
                        Delivery Items: {data?.length}{" "}
                      </p>
                      <p
                        className="p-medium"
                        style={{
                          fontFamily: "Inter, sans-serif",
                          color: "black",
                        }}
                      >
                                            <p
                      className="p-medium"
                      style={{
                        fontFamily: "Inter, sans-serif",
                        color: "black",
                      }}
                    >
                      {" "}
                      Schedule Date : {data[0]?.ScheduleDate ? moment(data[0]?.ScheduleDate).format(`${dateFormate.toUpperCase()}`) : ""}{" "}
                      <i
                        class={`fa ${
                          showScheduledateEdit ? "fa-times" : "fa-edit"
                        } cursor-pointer`}
                        onClick={() => setShowScheduledateEdit(!showScheduledateEdit)}
                      ></i>
                      {showScheduledateEdit && (
                        <div className="col-md-3">
                          <CommonDatePicker
                            FinalDate={scheduleDate}
                            handleDateChange={handlepaymentdatechange}
                          />
                        </div>
                      )}
                    </p>
                        {" "}
                        Created Date: {moment(data[0]?.CreatedDate).format(`${dateFormate.toUpperCase()} hh:mm:ss a`)}{" "}
                      </p>
                      <p
                        className="p-medium"
                        style={{
                          fontFamily: "Inter, sans-serif",
                          color: "black",
                        }}
                      >
                        {" "}
                        Created By: {data[0]?.CreatedBy}{" "}
                      </p>
                    </div>

                    <div className="col-md-6">
                      <p
                        className="p-medium"
                        style={{
                          fontFamily: "Inter, sans-serif",
                          color: "black",
                        }}
                      >
                        Departure Time :
                      </p>
                      <p
                        className="p-medium"
                        style={{
                          fontFamily: "Inter, sans-serif",
                          color: "black",
                        }}
                      >
                        {" "}
                        Modified Date: {data[0]?.ModifiedDate ? moment(data[0]?.ModifiedDate).format(`${dateFormate.toUpperCase()} hh:mm:ss a`) : ""}{" "}
                      </p>
                      <p
                        className="p-medium"
                        style={{
                          fontFamily: "Inter, sans-serif",
                          color: "black",
                        }}
                      >
                        {" "}
                        Modified By: {data[0]?.ModifiedBy}{" "}
                      </p>
                    </div>
                  </div>

                  <div
                    className="mt-3"
                    style={{ position: "relative", zIndex: "0" }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      <button
                        className="btn btn-sm btn-primary me-1 "
                        onClick={() => addNewRow("")}
                      >
                        Add Invoice
                      </button>
                      <button
                        className="btn btn-sm btn-primary me-1 "
                        onClick={() => addNewRow("empty")}
                      >
                        Add Empty Row
                      </button>
                      {/* <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={emptyInputBox}
                          onChange={(e) => setEmptyInputBox(e.target.checked)}
                        />
                        <label className="form-check-label">
                          Empty Input Row
                        </label>
                      </div> */}
                    </div>
                    <CommonMatrialReactTable
                      MainHeading="Sonar POS"
                      ReportHeading="Driver task Receipt"
                      columns={columns}
                      data={data}
                      startdate={""}
                      enddate={""}
                      columnGrouping={[]}
                      columnsVisibility={{}}
                      hodiExport={true}
                      setRowSelectData={setRowSelection}
                      state={{
                        rowSelection,
                      }}
                      muiRowDragHandleProps={muiRowDragHandleProps}
                      enableRowOrdering={true}
                      // handleCreateUser={handleCreateUser}
                      isDriverReport={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DriverTaskReceipt;
